export default "__VITE_ASSET__fngCnxII__"